document.addEventListener("DOMContentLoaded", () => {
	const checkboxes = document.querySelectorAll(".show_swatches");

	if (!checkboxes.length) {
		return;
	}

	window.toggleSwatches = (clickedCheckbox) => {
		const showSwatches = clickedCheckbox.checked;

		// Sync all checkboxes to match the clicked one
		checkboxes.forEach((cb) => (cb.checked = showSwatches));

		// Desktop: Toggle body class for CSS-based image swap
		// When ON (checked), show hand swatches instead of bottles
		document.body.classList.toggle("show-hand-swatches", showSwatches);

		// Mobile: Switch Flickity carousel slides
		// Slide 0 = bottle (default), Slide 1 = hand swatch
		const carousels = document.querySelectorAll(".mobile_ImageSlider");
		carousels.forEach((carousel) => {
			const flickityInstance = Flickity.data(carousel);
			if (flickityInstance) {
				// Select slide: 0 for bottle (OFF), 1 for hand swatch (ON)
				// Parameters: (index, isWrapped, isInstant)
				flickityInstance.select(showSwatches ? 1 : 0, false, true);
			}
		});

		// Save preference to sessionStorage
		sessionStorage.setItem("showSwatches", showSwatches);
	};

	// Apply saved state on page load, or default to showing hand swatches
	const savedState = sessionStorage.getItem("showSwatches");
	const shouldShowSwatches =
		savedState !== null ? JSON.parse(savedState) : true;

	checkboxes.forEach((el) => {
		el.checked = shouldShowSwatches;
	});
	if (checkboxes.length > 0) {
		window.toggleSwatches(checkboxes[0]);
	}

	// Attach event listeners to all toggle checkboxes
	checkboxes.forEach((el) =>
		el.addEventListener("change", (e) => toggleSwatches(e.target))
	);

	// MutationObserver to reapply toggle state after DOM updates (AJAX-loaded products)
	const observer = new MutationObserver(() => {
		const firstCheckbox = document.querySelector(".show_swatches");
		if (firstCheckbox?.checked) {
			window.toggleSwatches(firstCheckbox);
		}
	});

	const config = { childList: true, subtree: true };
	observer.observe(document.body, config);
});
